<template>
    <div class="main-blue-button">
        <slot></slot>
        <img v-if="preloader_button" style="object-fit: contain; width: 20px; height: 20px;" src="../../../assets/preloader-button.svg" />
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
    name: 'MainBlueButton',
    computed: {
        ...mapGetters(['preloader_button'])
    }
}
</script>

<style lang="scss" scoped>
    .main-blue-button {
        display: flex;
        width: fit-content;
        height: fit-content;
        padding: 10px;
        box-sizing: border-box;
        justify-content: center;
        align-content: center;
        align-items: center;
        background: #1C3B8D !important;
        border-radius: 9px;
        font-size: 14px;
        color: #fff;
        flex-direction: row;
        font-weight: 400;
        cursor: pointer;
        gap: 10px;
        &:hover {
            opacity: 0.8;
        }
    }
</style>

